import React, { Component } from 'react';
import Bugsnag from '@bugsnag/js'
import AppStore from '../flux/AppStore';
import Store from '../flux/Store';
import Actions from './../flux/Actions';
import AppActions from "../flux/AppActions";
import PersonalInfoStore from '../flux/PersonalInfoStore';
import {__} from "../Translator";
import Footer from "../components/Footer";
import Header from "../components/Header";
import StepIndicator from "../components/StepIndicator";
import FormGroup from "../components/FormGroup";
import './MailInsert.css';
import LanguageStore from '../flux/LanguageStore';
import dispatchDataLayerEvent, { eventTypes } from '../utils/dispatchDataLayerEvent';

class MailInsertScreen extends Component {
  subscriptions = [];
  constructor(props) {
      super(props);
      this.personalInfos = PersonalInfoStore.getState();
      this.initialInputFieldState = {
        'email': this.personalInfos.email,
        'terms_of_service': this.personalInfos.terms_of_service !== undefined ? this.personalInfos.terms_of_service : 0,
        'newsletter': this.personalInfos.newsletter !== undefined ? this.personalInfos.newsletter : 0,
        'personal_data_agreement': this.personalInfos.personal_data_agreement!== undefined ? this.personalInfos.personal_data_agreement : 0 ,
      };

      this.state = Object.assign({
        customProduct: AppStore.getCustomProduct(),
        errors: null,
        personal_infos: PersonalInfoStore.getState(),
        validEmail: !!this.personalInfos.email,
      }, this.initialInputFieldState);

      this.props.navigation.onBack(() => {
        this.props.navigation.navigate('configurator');
      });


      this.onInputChange = this.onInputChange.bind(this);
      this.onBookAppointmentResponse = this.onBookAppointmentResponse.bind(this);
      this.onCustomProductStored = this.onCustomProductStored.bind(this);

  }

  componentDidMount() {
    Store.events.bookAppointment.addListener(this.onBookAppointmentResponse);
    Store.events.createCustomProduct.addListener(this.onCustomProductStored);
    this.subscriptions.push(PersonalInfoStore.addListener(() => {
      this.setState({ personal_infos: PersonalInfoStore.getState() });
    }));
  }

  componentWillUnmount() {
    Store.events.bookAppointment.removeListener(this.onBookAppointmentResponse);
    Store.events.createCustomProduct.removeListener(this.onCustomProductStored);
    this.subscriptions.forEach(subscription => subscription.remove());
  }

  onCustomProductStored(data, error) {
    let savedProduct =  AppStore.getCustomProduct();
    let savingError = false;
    if(error){
      savingError = true;
    }
    var productSpecification = savedProduct.product.specification;

    var productSpecificationArray = Object.keys(productSpecification).map(key => {
      return productSpecification[key];
    });
    console.log(productSpecificationArray.filter(spec => spec.type === 'PART'),savedProduct.simpleSpecification);
    productSpecificationArray.filter(spec => spec.type === 'PART').forEach((part) =>{
        if(savedProduct.simpleSpecification.find(spec => {return spec.partCode === part.name}) === undefined){
          console.log("Can't find part "+ part.name +" for suit " + savedProduct.hash);
          Bugsnag.notify("Can't find part "+ part.name +" for suit " + savedProduct.hash);
          savingError = true;
        }
      }
    )
    if(savingError){
      AppActions.hideLoadingScreenOverlay();
      AppActions.showLoadingScreenOverlay(__('There was an error saving your garment. You are being redirected back, check your changes and save again. If repeated please contact the help desk.'));
      setTimeout(() =>{
        this.setState(this.initialInputFieldState, () => {
          AppActions.hideLoadingScreenOverlay();
          this.props.navigation.navigate('configurator');
        });
      }, 10000);

    }else{
      this.setState({ customProduct: AppStore.getCustomProduct() });
      this.onAppointmentFormSubmit();
      AppActions.showLoadingScreenOverlay(__('Sending the request to Dainese…'));
    }
  }

  validateEmail(email){
    var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    this.setState({ validEmail: re.test(String(email).toLowerCase()) });
  }

  onInputChange(event) {
    const target = event.target;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    const name = target.name;

    if (target.type === 'email'){
      this.validateEmail(target.value);
    }

    const errors = this.state.errors;

    if (errors && errors[name]) {
      delete errors[name];
    }

    this.setState({
      [name]: value,
      errors,
    });
  }

  onAppointmentFormSubmit() {
    this.submitClickTime = +new Date();

    // If we have a customProduct for the appointment, we use it, otherwise
    // we give the API some essential data to create a simple customProduct.
    const customProductData = this.state.customProduct.hash ? {
      custom_product_hash: this.state.customProduct.hash,
      preset_id: this.state.customProduct.color.code,
      perforated: +this.state.customProduct.perforated,
      custom_fitted: +this.state.customProduct.custom_fitted,
      custom_colored: +this.state.customProduct.custom_colored,
    } : {
      product_id: this.state.customProduct.product.id,
      preset: this.state.customProduct.color.name, // here for backwards compatibility.
      preset_id: this.state.customProduct.color.code,
      perforated: +this.state.customProduct.perforated,
      custom_fitted: +this.state.customProduct.custom_fitted,
      custom_colored: +this.state.customProduct.custom_colored,
    };

    AppActions.setPersonalInfo({
        email: this.state.email,
        terms_of_service: +this.state.terms_of_service,
        newsletter: +this.state.newsletter,
        personal_data_agreement: +this.state.personal_data_agreement,
    });

    // Merge the appointment data and the custom product data to book a new
    // appointment.
    Actions.bookAppointment({
      ...{
        email: this.state.email,
        terms_of_service: +this.state.terms_of_service,
        newsletter: +this.state.newsletter,
        personal_data_agreement: +this.state.personal_data_agreement,
        status: 'on_hold', //i'm saving only mail and user preferences
        language: LanguageStore.getState()
      },
      ...customProductData,
    });
  }

  onBookAppointmentResponse(data, error) {
    // We wrap the behaviour of this function in a anonymous function to control
    // when it's executed. See below: we need to assure at least two seconds
    // have passed after the submit is clicked.
    const next = () => {
      if (error && error.response && error.response.status === 422) {
        error.response.json().then(response => {
          this.setState({ errors: response.errors });
          AppActions.hideLoadingScreenOverlay();
        });
      } else if (error) {
        // Handle generic error
        console.error(error);
        AppActions.hideLoadingScreenOverlay();
      } else {
        this.setState(this.initialInputFieldState, () => {
          AppActions.hideLoadingScreenOverlay();
          this.props.navigation.navigate('configured');
        });
      }
    };
    const timeElapsedSinceSubmit = +new Date() - this.submitClickTime;
    const minimumTimeToElapse = 2 * 1000;

    if (timeElapsedSinceSubmit > minimumTimeToElapse) {
      next()
    } else {
      setTimeout(next, minimumTimeToElapse - timeElapsedSinceSubmit);
    }
  }

  blockBackButtonBrowser() {
    window.history.pushState(null, document.title, window.location.href);
    window.addEventListener('popstate', function (event){
      window.history.pushState(null, document.title,  window.location.href);
    });
  }

  render() {
    return (
      <div>
        <Header
          title={__('Configurator')}

        />

        <Footer navigation={this.props.navigation} />

        <StepIndicator currentScreen={this.props.navigation.currentScreen} />

        <div className="main">
          <div className="row">
            <div className="col-xs-8 col-xs-offset-2 text-center">
            <div className="main__hero">
              <h1 className="hero__title">{__('Enter your email address to save your garment')}</h1>
              <div className="hero__text">
                <div>
                  <p>{__('You will receive a unique Custom Works code in order to retrieve your design anytime')}</p>
                </div>
              </div>

              </div>
              <form className="form-horizontal mailInsertForm" onSubmit={e => {
                this.blockBackButtonBrowser();
                e.preventDefault();
                AppActions.showLoadingScreenOverlay(__('Saving customization…'));

                  Actions.createCustomProduct(this.state.customProduct, {
                    email: this.state.email,
                    status: 'on_hold', // @todo 2020-03-17 extract into a constant
                  });

                  dispatchDataLayerEvent({
                    event: eventTypes.EMAIL_SUBMIT,
                    user_type: window.USER_TYPE,
                  });
              }}>
                <div className="row">
                <FormGroup className="form-group" style={{width: '100%', marginTop:' 4rem', marginBottom:'2rem'}} name="email" errors={this.state.errors}>
                  <input type="email" name="email" value={this.state.email} className="form-control" placeholder={__('email*')} required onChange={this.onInputChange} />
                </FormGroup>
                <FormGroup name="terms_of_service" errors={this.state.errors} className="checkbox">
                    <label className="u-fw-600">
                      <input type="checkbox" name="terms_of_service" checked={ !! this.state.terms_of_service} onChange={this.onInputChange} required />
                      <span className="checkbox__trigger" />
                      {__('* By signing this form, you agree that you have read and understood the Dainese S.p.A. Privacy Policy, available at Privacy Policy Dainese, and agree to permit Dainese S.p.A. to collect and use the personal data accordingly.')}
                    </label>
                </FormGroup>

                  <FormGroup name="newsletter" errors={this.state.errors} className="checkbox">
                    <label className="u-fw-600">
                      <input type="checkbox" name="newsletter" checked={ !! this.state.newsletter} onChange={this.onInputChange} />
                      <span className="checkbox__trigger" />
                      {__('I agree to receive special offers, membership benefits, newsletter and brand communications via email and understand I can unsubscribe any time')}
                    </label>
                  </FormGroup>

                <FormGroup name="personal_data_agreement" errors={this.state.errors} className="checkbox">
                    <label className="u-fw-600">
                      <input type="checkbox" name="personal_data_agreement" checked={ !! this.state.personal_data_agreement} onChange={this.onInputChange} />
                      <span className="checkbox__trigger" />
                      {__('I consent to provide usage and personal data for a better processing of my interests')}
                    </label>
                </FormGroup>
                  <span className="form__requiredText">
                      (*) {__('Required')}
                  </span>
                </div>
                <div className="u-ta-center">
                  <button className="btn btn-primary btn-xlg" disabled={!this.state.validEmail} >
                    {__('Submit')}
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default MailInsertScreen;



// WEBPACK FOOTER //
// ./src/screens/MailInsert.js